import api from '../api';
import { downloadOrViewArquivo } from '@app/helpers/download';
import { IArquivo } from '@app/types/core.types';
import { vtObjToQueryString } from '@app/helpers/objHelper';
import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';
import { notification } from '@digital/ui';

const controller = 'sasDocumentoOrdemCompra'

export const substituirAnexoDocumentoOrdemCompra = (values: {
  sasDocumentoOrdemCompraId?: string,
  justificativa: string,
  arquivo: any,
  validaJustificativa?: string,
}) => {
  const form = new FormData();
  form.append('sasDocumentoOrdemCompraId', values.sasDocumentoOrdemCompraId || '');
  form.append('justificativa', values.justificativa);
  form.append('file', values.arquivo);
  form.append('validaJustificativa', values.validaJustificativa || 'true');

  return api.put(`${controller}/substituirAnexo`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const substituirSasArquivoDocumentoOrdemCompra = (values: {
  sasArquivoDocumentoOrdemCompraId: string,
  description: string,
  file: any,
  forceVersion?: boolean,
  ehArquivoConsolidacaoAnexosFinais?: boolean
}) => {
  const form = new FormData();

  form.append('sasArquivoDocumentoOrdemCompraId', values.sasArquivoDocumentoOrdemCompraId || '');
  form.append('description', values.description);
  form.append('file', values.file);
  form.append('forceVersion', values.forceVersion ? 'true' : 'false');
  form.append('ehArquivoConsolidacaoAnexosFinais', values.ehArquivoConsolidacaoAnexosFinais ? 'true' : 'false');

  return api.put(`${controller}/substituirSasArquivoDocumentoOrdemCompra`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

interface IIncluirArquivosOrdemCompra {
  documentoId?: string;
  sasPropostaId?: string;
  ordemCompraId: string;
  file?: any;
  files?: any[]
  descricao?: string;
  multiple?: boolean;
  sasTipoDocumentoId?: string;
  ehArquivoConsolidacaoAnexosFinais?: boolean;
}

export const incluirDocumento = (values: IIncluirArquivosOrdemCompra) => {
  const form = new FormData();
  form.append('documentoId', values.documentoId || '');
  form.append('ordemCompraId', values.ordemCompraId);
  form.append('sasTipoDocumentoId', values.sasTipoDocumentoId || '');
  form.append('sasPropostaId', values.sasPropostaId || '');

  form.append('descricao', values.descricao || '');
  form.append('multiple', values.multiple ? values.multiple.toString() : "false");
  form.append('file', values.file);

  form.append('ehArquivoConsolidacaoAnexosFinais', values.ehArquivoConsolidacaoAnexosFinais ? 'true' : 'false');

  if (values.files) {
    values.files.map((c: any, i: any) => {
      form.append(`arquivos`, c);
    });
  }

  return api.put(`${controller}/incluirDocumento`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

interface IIncluirDocumentoParecerTecnico {
  ordemCompraId: string
  sasParecerTecnicoRevisaoId: string
  file: any
}

export const incluirDocumentoParecerTecnico = (values: any) => {
  const form = new FormData();
  form.append('ordemCompraId', values.ordemCompraId);
  form.append('sasParecerTecnicoRevisaoId', values.sasParecerTecnicoRevisaoId);
  form.append('file', values.file)
  form.append('multiple', 'false')
  form.append('descricao', 'Documento Anexo Revisão Parecer Técnico');
  return api.put(`${controller}/incluirDocumento`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export const downloadArquivo = (id: string, nomeDoArquivo: string, isSasDocumentoOrdemCompra = false) => {
  downloadOrViewArquivo({
    url: `/api/${controller}/DownloadArquivo?id=${id}&isSasDocumentoOrdemCompra=${isSasDocumentoOrdemCompra}`,
    nomeDoArquivo,
    atributoId: "downloadArquivoSas"
  });
};

export const viewArquivo = async (id: string, nomeDoArquivo: string) => {
  downloadOrViewArquivo({
    url: `/api/${controller}/DownloadArquivo?id=${id}`,
    nomeDoArquivo,
  }, true);
};

interface IDownloadArquivosOrdemCompra {
  ordemCompraId: string;
  nomeArquivo?: string;
  ordemCompraNumero?: number;
  sasTipoDocumentoOrdemCompraId?: string;
  multiple?: boolean;
  isPropostas?: boolean;
  sasPropostaId?: string;
  isOrdem?: boolean;
  hasDocsOc?: boolean;
  sasTipoDocumentosIds?: string[];
  ehArquivoConsolidacaoAnexosFinais?: boolean;
}

export const downloadArquivosOrdemCompra = ({
  ordemCompraId,
  nomeArquivo,
  ordemCompraNumero,
  multiple = false,
  sasTipoDocumentoOrdemCompraId,
  sasPropostaId,
  isPropostas = false,
  isOrdem = false,
  hasDocsOc = false,
  sasTipoDocumentosIds = [],
  ehArquivoConsolidacaoAnexosFinais
}: IDownloadArquivosOrdemCompra) => {

  nomeArquivo = nomeArquivo || 'documentacao';

  var query = vtObjToQueryString({
    ordemCompraId,
    nomeArquivo,
    ordemCompraNumero,
    multiple,
    sasTipoDocumentoOrdemCompraId,
    sasPropostaId,
    isPropostas,
    isOrdem,
    hasDocsOc,
    sasTipoDocumentosIds,
    ehArquivoConsolidacaoAnexosFinais
  });

  // let urlParam = `ordemCompraId=${ordemCompraId}&documentosProcesso=${multiple}&sasTipoDocumentoOrdemCompraId=${sasTipoDocumentoOrdemCompraId}&sasPropostaId=${sasPropostaId}&isPropostas=${isPropostas}&isOrdem=${isOrdem}&hasDocsOc=${hasDocsOc}`;

  // sasTipoDocumentosIds.map(a => {
  //   urlParam += `&sasTipoDocumentosIds=${a}`;
  // })

  downloadOrViewArquivo({
    url: `/api/${controller}/DownloadDocumentosOrdemCompra?${query}`,
    nomeDoArquivo: `${nomeArquivo}_oc_${ordemCompraNumero}.zip`,
    atributoId: "downloadArquivosOrdemCompra"
  });
}

export interface ISasDocumentoOrdemCompra {
  id: string;
  descricao: string;
  sasStatusDocumentoOrdemCompraId: string;
  arquivoNome: string;
  arquivoId: string;
  contemComentario: boolean;
  multiple: boolean;
  tipoDocumentoOrdemCompraId: string;
  fixo: boolean;
  ordem: number;
  arquivoNomeDownload: string;
  arquivoNomeAlternativo: string;
}
export interface ISasArquivoFornecedor
{
  id : string;
  descricao: string;
  arquivoNomeDownload : string;
}
export interface IRequisitosAcao {
  requerUpload?: boolean;
  requerJustificativa?: boolean;
  RequerJustificativaQuandoAceitar?: boolean;
  requerValor?: boolean;
  requerConfirmacao?: boolean;
  aceitarOuRecusar?: boolean;
  visualizarDocumento: boolean;
  requerUploadQuandoRecusado?: boolean;
  requerUploadQuandoAceitar?: boolean;
  requerCondicaoPagamento?: boolean;
  requerMultiplosArquivos?: boolean;
  textoAceitar?: string;
  textoRecusar?: string;
}

export interface IAcaoFornecedor {
  id: string;
  acao: string;
  descricao: string;
  tipoUI: string;
  tipoAcao: string;
  requisitos: IRequisitosAcao;
  dataLimite: Date;
  dataExecucao: Date;
  statusAcao: string;
  descricaoConfirmacao: string;
  documentoFornecedor: ISasArquivoFornecedor;
  tipoDocumentoId?: string;
  justificativa?: string;
}


export const getDocumentosOrdemCompraMaisPropostasId = (filtro: {
  ordemCompraId: string,
  sasTipoDocumentosIds?: string[],
  sasPropostaId?: string,
  hasDocsOc?: boolean
}) => {
  var query = vtObjToQueryString(filtro);
  return api.get<ISasDocumentoOrdemCompra[]>(`${controller}/getDocumentosOrdemCompraMaisPropostas?${query}`);
}

export const getDocumentosConsolidacaoAnexosFinais = (filtro: { ordemCompraId: string }) => {
  var query = vtObjToQueryString(filtro);
  return api.get<ISasDocumentoOrdemCompra[]>(`${controller}/DocumentosConsolidacaoAnexosFinais?${query}`);
}

export const updateDocumentosConsolidacaoAnexosFinais = (sasArquivoDocumentoOrdemCompraId: string, novoNome: string) => {
  return api.put(`${controller}/DocumentosConsolidacaoAnexosFinais?sasArquivoDocumentoOrdemCompraId=${sasArquivoDocumentoOrdemCompraId}`
    , { novoNome }
    , { disableNotification: 'true' });
}

export const deleteDocumentosConsolidacaoAnexosFinais = (sasDocumentoOrdemCompraId: string, sasArquivoDocumentoOrdemCompraId: string) => {
  return api.delete(`${controller}/${sasDocumentoOrdemCompraId}/DocumentosConsolidacaoAnexosFinais?sasArquivoDocumentoOrdemCompraId=${sasArquivoDocumentoOrdemCompraId}`);
}


export const getDocumentosOrdemCompraId = (filtro: {
  ordemCompraId: string,
  sasTipoDocumentoId?: string,
  sasPropostaId?: string
}) => {
  var query = vtObjToQueryString(filtro);
  return api.get<ISasDocumentoOrdemCompra[]>(`${controller}/getDocumentosOrdemCompra?${query}`);
}

export const getDocumentosOrdemCompraHandover = (filtro: {
  ordemCompraId: string,
  sasTipoDocumentoId?: string,
  sasPropostaId?: string
}) => {
  var query = vtObjToQueryString(filtro);
  return api.get<HandoverDocumentosResultado>(`${controller}/getDocumentosOrdemCompraHandover?${query}`);
}

export interface IArquivosDocumentoOrdemCompraByOcProps {
  ordemCompraId: string;
  sasTipoDocumentoId?: string;
  sasPropostaId?: string;
  ordemCompraRodadaNegociacaoId?: string;
}

export const getArquivosDocumentoOrdemCompraByOc = (filtro: IArquivosDocumentoOrdemCompraByOcProps) => {
  var query = vtObjToQueryString(filtro);

  return api.get<IArquivo[]>(`${controller}/getArquivosDocumentoOrdemCompraByOc?${query}`);
}

export interface IUpdateSasDocumentoOrdemCompraCommand {
  sasDocumentoOrdemCompraId: string;
  sasStatusDocumentoOrdemCompraId?: string;
  descricao?: string;
  exibirFornecedor?: boolean;
  handover?: boolean;
  ehDescricaoAlternativa?: boolean;
  editavelRequisitante?: boolean;
}

export const updateSasDocumentoOrdemCompraCommand = (dados: IUpdateSasDocumentoOrdemCompraCommand) => {
  return api.put(`${controller}/updateSasDocumentoOrdemCompraCommand`, dados)
}

export const getArquivosDocumento = (sasDocumentoOrdemComraId: string) => {
  return api.get(`${controller}/getArquivosDocumentoOrdemCompra/${sasDocumentoOrdemComraId}`)
}

export const getSasComentarioOrdemCompra = (sasDocumentoOrdemComraId: string) => {
  return api.get(`${controller}/getSasComentarioOrdemCompra/${sasDocumentoOrdemComraId}`)
}

export const saveSasComentarioOrdemCompra = (form: any) => {
  return api.put(`${controller}/saveSasComentarioOrdemCompra`, form)
}

export const deleteAnexos = (ids: string[] = []) => {
  return api.post(`${controller}/deleteAnexos`, { ids: ids }, { disableNotification: 'true' })
}

export const deleteDocumento = (sasDocumentoOrdemCompraId: string, sasArquivoDocumentoOrdemCompraId: string) => {
  return api.delete(`${controller}/${sasDocumentoOrdemCompraId}/deleteDocumento?sasArquivoDocumentoOrdemCompraId=${sasArquivoDocumentoOrdemCompraId}`);
}

export const exclusaoLogicaDocumento = (id: string) => {
  return api.put(`${controller}/exclusaoLogicaDocumento/${id}`, {}, { disableNotification: 'true' })
}

export const updateListSasDocumentoOrdemCompraCommand = (values: ISasDocumentoOrdemCompra[]) => {
  return api.put(`${controller}/updateListSasDocumentoOrdemCompraCommand`, {
    sasDocumentoOrdemCompras: values
  });
};

export interface HandoverArquivo {
  id: string;
  nome: string;
  extensao: string | null;
}

export interface HandoverDocumentosResultado {
  ativos: ISasDocumentoOrdemCompra[];
  excluidos: ISasDocumentoOrdemCompra[];
  arquivosHandover: HandoverArquivo[];
}

export interface HandoverOrdemCompraInput {
  minutaArquivoId?: string;
  pqArquivoId?: string;
  isMultiplosGestores: boolean;
  isFaturamentoDireto: boolean;
  isAdiantamentoFinanceiro: boolean;
}

export const HandOverOrdemCompra = (
  ordemCompraId: string,
  input: HandoverOrdemCompraInput
) => {
  return api.put(`${controller}/handOverDocumentosOrdemCompra/${ordemCompraId}`, input);
};

export const DesfazerExclusoesHandOverOrdemCompra = (ordemCompraId: string) => {
  return api.get(`${controller}/desfazerExclusoesHandover/${ordemCompraId}`);
};

export const DownloadOrdemCompraPropostaTecnica = (ordemCompraKey: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/${controller}/DownloadOrdemCompraPropostaTecnica?ordemCompraId=${ordemCompraKey}`, {
      responseType: 'blob',
    })
      .then(resp => {
        //Get filename from response header
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '');
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            notification.error('Template não encontrado.');
          }
        }
      }),
  );
};

export const getDocumentosOrdemCompraEditavelRequisitante = (ordemCompraId: string) => {
  return api.get(`${controller}/GetDocumentosOrdemCompraEditavelRequisitante/${ordemCompraId}`);
};

export const substituirAnexoRequisitante = (values: {
  sasDocumentoOrdemCompraId?: string,
  justificativa: string,
  arquivo: any,
}) => {
  const form = new FormData();
  form.append('sasDocumentoOrdemCompraId', values.sasDocumentoOrdemCompraId || '');
  form.append('justificativa', values.justificativa);
  form.append('file', values.arquivo);

  return api.put(`${controller}/SubstituirAnexoRequisitante`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const incluirDocumentoRequisitante = (values: {
  ordemCompraId: string,
  descricao: string,
  file: any,
}) => {
  const form = new FormData();
  form.append('ordemCompraId', values.ordemCompraId);
  form.append('descricao', values.descricao || '');
  form.append('file', values.file);

  return api.put(`${controller}/IncluirDocumentoRequisitante`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getDocumentosOrdemCompraAjusteOrcamentario = (ordemCompraId: string) => {
  return api.get<ISasDocumentoOrdemCompra[]>(`${controller}/GetDocumentosOrdemCompraAjusteOrcamentario/${ordemCompraId}`);
};
